import React, { useState } from 'react';

import cx from 'classnames';

import { ChevronDownIcon } from '@shared/assets';
import { InteractiveElement } from '@shared/components';

import { FieldInfoData, IProductActivationInfo } from '@shared/types';
import styles from './ProductActivationInfo.module.scss';
import { OM_ONBOARDING } from '@shared/constants';

const ProductActivationInfo = ({ infoList = [] }: IProductActivationInfo) => {
	const [openInfoIndex, setOpenInfoIndex] = useState(0);

	const renderContent = (info: FieldInfoData) => {
		if (info.htmlContent) {
			return info.htmlContent;
		}
		return (
			<>
				<p className={styles.answerText}> {info.answer} </p>
				{info.imageUrl && (
					<img className={styles.infoImg} src={info.imageUrl} alt="Info" />
				)}
			</>
		);
	};

	return (
		<div className={styles.infoCard}>
			{infoList.map((info, index: number) => (
				<div key={info.question} className={styles.infoContent}>
					<InteractiveElement
						type="div"
						onClick={() => setOpenInfoIndex(index)}
						className={styles.headerContainer}
					>
						<p className={styles.questionText}>{info.question}</p>
						{infoList.length > 1 && (
							<ChevronDownIcon
								data-id={OM_ONBOARDING.PRODUCT_INFO_EXPAND_ICON}
								className={cx(styles.chevronIcon, {
									[styles.rotate]: openInfoIndex === index,
								})}
							/>
						)}
					</InteractiveElement>
					<div
						className={cx(styles.infoBody, {
							[styles.open]: openInfoIndex === index,
						})}
					>
						{renderContent(info)}
					</div>
				</div>
			))}
		</div>
	);
};

export default ProductActivationInfo;
